import createVueComponent from '../createVueComponent';

const Send = createVueComponent('SendIcon', [
  ['path', { d: 'm22 2-7 20-4-9-9-4Z', key: '1q3vgg' }],
  ['path', { d: 'M22 2 11 13', key: 'nzbqef' }],
]);

export default Send;
